module.exports = __webpack_public_path__ + "img/ESFP.8c5fb150.png";